module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<dt>\n    <label for="contract-extra-contracted-power">' +
((__t = ( i18next.t('tariffs.required_power') )) == null ? '' : __t) +
' (kW)&nbsp;*</label>\n</dt>\n<dd>\n    <input class="text" id="contract-extra-contracted-power" name="contract[extra][contracted_power]" type="number">\n</dd>\n';

}
return __p
}